export const ONE_MB = 1000000;
export const ONE_GB = 1000000000;

export const MP4_FILE_TYPE = 'video/mp4';
export const PNG_FILE_TYPE = 'image/png';
